import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendCandidateOutreachEmailComponent } from './send-candidate-outreach-email.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { TooltipModule } from 'ngx-bootstrap';
import { CandidateCardIconsModule } from '../candidate-card-icons/candidate-card-icons.module';

@NgModule({
  declarations: [SendCandidateOutreachEmailComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    TooltipModule.forRoot(),
    CandidateCardIconsModule
  ],
  exports: [SendCandidateOutreachEmailComponent],
  entryComponents: [SendCandidateOutreachEmailComponent]
})
export class SendCandidateOutreachEmailModule { }
